const BRAND_DATA: Record<string, {
  name: string;
  extensionDisplayName: string;
  extensionUrls: { chrome: string; edge: string; firefox: string };
  hasSensor: boolean;
  hasJamf: boolean;
  primaryColor: string;
  logoLabel: string;
}> = {
  acium: {
    name: 'Acium',
    extensionDisplayName: 'Acium Extension',
    extensionUrls: {
      chrome: 'https://chromewebstore.google.com/detail/acium-chrome-extension/kcgcgklndcbhdmfgofkbeeafainmnpfg',
      edge: 'https://microsoftedge.microsoft.com/addons/detail/acium-unified-browser-s/kocjkpljedpgcanbijefjlijhbpagdlo',
      firefox: 'https://addons.mozilla.org/en-US/firefox/addon/acium-unified-browser-security/',
    },
    hasSensor: true,
    hasJamf: true,
    primaryColor: '#cf5820',
    logoLabel: '',
  },
  itopia: {
    name: 'Secure Class',
    extensionDisplayName: 'itopia Extension',
    extensionUrls: {
      chrome: 'https://chromewebstore.google.com/detail/acium-chrome-extension/kcgcgklndcbhdmfgofkbeeafainmnpfg',
      edge: 'https://microsoftedge.microsoft.com/addons/detail/acium-unified-browser-s/kocjkpljedpgcanbijefjlijhbpagdlo',
      firefox: 'https://addons.mozilla.org/en-US/firefox/addon/acium-unified-browser-security/',
    },
    hasSensor: true,
    hasJamf: false,
    primaryColor: '#61c993',
    logoLabel: '',
  },
  dizzion: {
    name: 'Halo',
    extensionDisplayName: 'Halo Secure Extension',
    extensionUrls: {
      chrome: 'https://chromewebstore.google.com/detail/dizzion-halo/pfknmgfdbhnanljpjijbaioohgedbdjd',
      edge: '',
      firefox: '',
    },
    hasSensor: false,
    hasJamf: false,
    primaryColor: '#ef2878',
    logoLabel: 'Halo',
  },
};


const brandingKey = ('itopia' as string).toLowerCase();
const brandData = BRAND_DATA[brandingKey] ?? BRAND_DATA['acium'];

export const environment = {
  production: false,
  branding: {
    theme: brandingKey,
    name: brandData.name,
    extensionDisplayName: brandData.extensionDisplayName,
    extensionUrls: brandData.extensionUrls,
    hasSensor: brandData.hasSensor,
    hasJamf: brandData.hasJamf,
    primaryColor: brandData.primaryColor,
    logoLabel: brandData.logoLabel,
  },
  chekIframeNavigation: false,
};
